import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { formatToMonthYear } from "../../../../../lib/utils/date-utils";
import Link from "next/link";
export default function FccBottomSheet(t0) {
  const $ = _c(13);
  const {
    digitalProfile
  } = t0;
  const {
    fccMembership
  } = digitalProfile;
  fccMembership && fccMembership?.id !== null;
  let t1;
  if ($[0] !== fccMembership.memberSince) {
    t1 = formatToMonthYear(fccMembership.memberSince);
    $[0] = fccMembership.memberSince;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const verfiedSince = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-[54px] h-[54px] flex justify-center items-center rounded-[4px] bg-gradient-to-b from-[#F26422] to-[#EC1E22] border-[2px] border-[#EC9468] "><div className="w-[42px] h-[40px]  relative"><Image priority={true} src="/assets/fcc.svg" layout="fill" className="object-cover " sizes="100%" alt="fcc logo" /></div></div>;
    t3 = <p className="m3-title-large text-[--textWarningWarning]">Fevicol Champion’s Club </p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-[--textSecondarySecondary] m3-body-medium">Verified member since</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== verfiedSince) {
    t5 = <div className="flex items-center gap-2 px-4">{t2}<div>{t3}<div className="flex gap-1 ">{t4}<p className="text-[--textPrimaryPrimary] m3-label-large-prominent ">{verfiedSince}</p></div></div></div>;
    $[5] = verfiedSince;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <hr className="my-4 border-t border-[--colorDisabledOnColorDisabled]" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-[--textWarningWarning]">Fevicol Champions’ Club (FCC)</span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="m3-body-large text-[--textPrimaryPrimary]">{t7} is an ethnic social platform that brings woodworking contractors together to boost their personal and professional growth. It is a pan-India community-based program where people of the woodworking industry learn new techniques, build networks, and earn recognition for their work. Its widespread presence makes it the single largest platform for contractors.<br /><br />FCC was introduced on 20th December 2002 in cities of Kanpur and Surat. Started as a simple club with an aim of being a social leveler for contractors, it has now branched out to a number of initiatives serving the entire nation. It does something for all its stakeholders including contractors, their families, carpenters, dealers, employees of Fevicol, and the general public.</p>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="py-4">{t6}<div className="px-6 flex flex-col gap-4">{t8}<Link href="https://fevicol.in/community-initiative/" target="_blank"><p className="text-[--textLinkOnSurfaceLink] m3-label-large py-[10px] px-3  ">Know more about FCC</p></Link></div></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5) {
    t10 = <div>{t5}{t9}</div>;
    $[11] = t5;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
}